var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Settings from '@web/components/Settings/Settings';
import { Page } from '@web/pages/layout/Page';
import { usePageTitle } from '@web/utility/hooks/usePageTitle';
import { CanAccessToPage } from '@web/utility/wrapper/CanAccess';
import { ScopeUIPageEnum } from '@workalizer/shared';
export var SettingsView = function () {
    usePageTitle('Settings');
    return (_jsx(CanAccessToPage, __assign({ scope: ScopeUIPageEnum.PAGE_SETTINGS }, { children: _jsx(Page, { children: _jsx(Settings, {}) }) })));
};
export default SettingsView;
